// extracted by mini-css-extract-plugin
export default {"container":"ContainerWrapper_container__6qZWP"};